import { useQuery } from "@apollo/client/react";
import styled from "@emotion/styled";
import { List as F7List, ListButton, Sheet } from "framework7-react";
import { useCallback } from "react";

import { EntrySummary } from "@/components/EntrySummary";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { getFragmentData } from "@/generated/graphql";
import { EntryFragmentDoc, GetEntryDocument } from "@/generated/graphql/graphql";
import { useSheetPageReady } from "@/hooks/useSheetPageReady";

const List = styled(F7List)`
  a {
    text-align: left;
  }
`;

export const EntrySheetPage = createPage("EntrySheetPage", PageComponent);

function PageComponent({ pageName, f7route, f7router }: PageComponentProps) {
  const { getPageProps, swipeHandler, isPageReady } = useSheetPageReady(pageName);

  const entryId = f7route.params.entryId as string;
  const { data } = useQuery(GetEntryDocument, {
    skip: !isPageReady,
    variables: { id: entryId },
  });
  const entry = getFragmentData(EntryFragmentDoc, data?.entry);
  const close = useCallback(() => f7router.back(), [f7router]);

  return (
    <Sheet
      data-component={pageName}
      {...getPageProps()}
    >
      {swipeHandler}
      {entry && (
        <>
          <EntrySummary entry={entry} />
          <List>
            <ListButton
              title="気分の変更"
              onClick={() => {
                close();
                f7router.navigate(`/modals/entries/${entry.id}/update-feeling/`);
              }}
            />
            <ListButton
              title="カテゴリの変更"
              onClick={() => {
                close();
                f7router.navigate(`/modals/entries/${entry.id}/change-category/`);
              }}
            />
            <ListButton
              title="キャンセル"
              onClick={close}
            />
          </List>
        </>
      )}
    </Sheet>
  );
}
